import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import './Partenaires.scss';

const PartnerLogo = ({ logo, abbr, name, color }) => {
  const [imgError, setImgError] = useState(!logo);
  if (!imgError && logo) {
    return (
      <img
        src={logo}
        alt={name}
        className="partner-real-logo"
        onError={() => setImgError(true)}
      />
    );
  }
  return (
    <div className="partner-abbr" style={{ background: `${color}22`, color }}>
      {abbr}
    </div>
  );
};

const Partenaires = () => {
  const partnerCategories = [
    {
      title: "Universités & Écoles",
      partners: []
    },
    {
      title: "Entreprises",
      partners: [
        { name: "FREJUS ZAMBLE", logo: "/Logo_frejus.jpg", abbr: "FZ", color: "#1a3a6b" },
        { name: "SYTELIS", logo: "/logo_sytelis.png", abbr: "SYTELIS", color: "#0d5c2d" },
      ]
    },
    {
      title: "Organisations Internationales",
      partners: []
    }
  ];

  const benefits = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: "Accès aux Talents",
      description: "Recrutez parmi les meilleurs étudiants africains formés à l'excellence"
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7l10 5 10-5-10-5z"/>
          <path d="M2 17l10 5 10-5"/>
          <path d="M2 12l10 5 10-5"/>
        </svg>
      ),
      title: "Visibilité",
      description: "Augmentez votre notoriété auprès de la communauté étudiante africaine"
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 6v6l4 2"/>
        </svg>
      ),
      title: "Impact Social",
      description: "Contribuez au développement du capital humain africain"
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
          <line x1="12" y1="22.08" x2="12" y2="12"/>
        </svg>
      ),
      title: "Réseau",
      description: "Rejoignez un écosystème d'acteurs engagés pour l'éducation"
    }
  ];

  const partnershipTypes = [
    {
      type: "Partenaire Académique",
      description: "Collaboration avec les universités et écoles pour l'accès aux étudiants et la co-création de programmes",
      features: ["Accès aux étudiants", "Co-création de contenu", "Événements conjoints"]
    },
    {
      type: "Partenaire Financier",
      description: "Soutien financier pour nos programmes de bourses et de formation",
      features: ["Bourses d'études", "Financement de programmes", "Visibilité premium"]
    },
    {
      type: "Partenaire Technique",
      description: "Expertise et ressources pour renforcer nos programmes de formation",
      features: ["Mentorat d'experts", "Formations techniques", "Stages et emplois"]
    },
    {
      type: "Partenaire Stratégique",
      description: "Collaboration à long terme pour le développement de l'écosystème",
      features: ["Gouvernance", "Stratégie commune", "Innovation"]
    }
  ];

  return (
    <div className="partenaires-page">
      <PageHeader 
        title="Nos Partenaires" 
        subtitle="Ensemble pour l'excellence africaine"
        breadcrumb={['Accueil', 'Partenaires']}
        image="/assets/IMG/etudiants.png"
        hideText={true}
      />

      <div className="partenaires-container">
        <section className="intro-section">
          <h2>Construisons Ensemble l'Avenir de l'Afrique</h2>
          <p className="intro-text">
            BE TALENTED collabore avec des universités, entreprises et organisations internationales 
            partageant notre vision d'une génération africaine d'excellence. Nos partenariats stratégiques 
            permettent de maximiser l'impact de nos programmes et d'offrir les meilleures opportunités à nos bénéficiaires.
          </p>
        </section>

        <section className="partners-showcase">
          {partnerCategories.map((category, index) => (
            <div key={index} className="partner-category">
              <h3>{category.title}</h3>
              <div className="partners-grid">
                {category.partners.map((partner, idx) => (
                  <div key={idx} className="partner-card">
                    <PartnerLogo logo={partner.logo} abbr={partner.abbr} name={partner.name} color={partner.color} />
                    <p>{partner.name}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </section>

        <section className="benefits-section">
          <h2>Pourquoi Devenir Partenaire ?</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="partnership-types">
          <h2>Types de Partenariats</h2>
          <div className="types-grid">
            {partnershipTypes.map((partnership, index) => (
              <div key={index} className="partnership-card">
                <div className="partnership-header">
                  <div className="partnership-number">{index + 1}</div>
                  <h3>{partnership.type}</h3>
                </div>
                <p>{partnership.description}</p>
                <ul className="features-list">
                  {partnership.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        <section className="cta-section">
          <div className="cta-content">
            <h2>Devenez Partenaire</h2>
            <p>
              Rejoignez notre réseau de partenaires engagés pour former la prochaine génération 
              de leaders africains. Ensemble, construisons un avenir d'excellence.
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="cta-btn primary">Nous Contacter</Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Partenaires;
